import React, { useState, useEffect } from "react";
import "./DynamicFilter.scss";
import BaseModal from "../BaseModal/BaseModal";
import { useSelector } from "react-redux";
import Select from "../Select/Select";
import { convertFormsToJson } from "../../../util/utilfunctions/utilFunctions";
import BaseInput from "../BaseInput/BaseInput";
import { useDispatch } from "react-redux";
import { setFormData } from "../../../store/redux/customForms";
import { useForm } from "react-hook-form";
import BaseButton from "../BaseButton/BaseButton";
import { Box, Button, Typography } from "@mui/material";
import BaseDrawer from "../BaseDrawer/BaseDrawer";
import BaseCard from "../BaseCard/BaseCard";

function DynamicFilter({
  handleClose,
  filterName,
  open,
  userHeader,
  setFilter,
  handleSelect,
  onSubmit,
  conditionalFields,
  filterOptions,
  filters
}) {
  const [activeFilter, setActiveFilter] = useState({});
  const filtersData =  useSelector((state) => state.customForms.formCache[filterName] || []);
  const dispatch = useDispatch();

  const fetchForm = async () => {
    try {
      const response = await fetch(`/forms/${filterName}.json`);
      const formResponseData = await response.json();
      const convertedForms = convertFormsToJson(formResponseData);
      dispatch(setFormData({ formName: filterName, data: convertedForms }));
    } catch (error) {
      console.error("Failed to fetch form data:", error);
    }
  };


  // const validationSchema = generateValidationSchema(filtersData);

  const {
    register,
    handleSubmit,
    formState: { errors },
    reset,
    setValue,
    getValues,
    watch,
  } = useForm({
    // resolver: yupResolver(validationSchema),
    mode: "onChange",
  });

  useEffect(() => {
    fetchForm();
    console.log(filtersData.filter((filter) => filter.type === "select").map((filter) => filter));
  }, [dispatch, filterName, filtersData.length]);

  const handleFilterClick = (filter) => {
    setActiveFilter(filter);
    console.log(filter)
    setFilter(filter, filtersData);
  };

  const submitForm = async (data) => {
    await onSubmit(data, filtersData);
  };

  const renderFilter = (filter, register, index) => {
    switch (filter.type) {
      case "button":
        return (
          <Box className="filter-modal-section" key={index}>
            <Typography variant="h5">{filter.label}</Typography>
            <Box className="filter-buttons d-flex gap-2">
              {filter.options.map((option, index) => (
                <Button
                  key={index}
                  className={option === activeFilter ? "highlighted" : ""}
                  onClick={() => handleFilterClick(option)}
                >
                  {option}
                </Button>
              ))}
            </Box>
          </Box>
        );
      case "select":
        return (
          <Box className="filter-modal-section" key={index}>
            <Box className="filter-buttons d-flex gap-2">
              <Select
                onChange={(e) => {
                  setValue(filter.name, e.target.value);
                  handleSelect(e.target.value, filtersData); // Call handleSelect
                }}
                label={filter.label}
                type={filter.type}
                key={filter.name}
                {...register(filter.name)}
                options={filterOptions[filter.name] ? filterOptions[filter.name] : []}
                value={watch(filter.name)} // Bind the value to react-hook-form's watch
              />
            </Box>
          </Box>
        );
      case "date":
        return (
          <BaseInput
            label={filter.label}
            type={filter.type}
            placeholder={filter.placeholder}
            disabled={filter.disabled}
            setValue={setValue}
            {...register(filter.name)}
          />

        );
      default:
        return null;
    }
  };

  return (
    <BaseDrawer
      open={open} 
      handleClose={handleClose} 
      height="80vh"
      title={userHeader}
    >
      <BaseCard>
        <Box className="filter-modal-container">
          <form onSubmit={handleSubmit(submitForm)}>
            <Box className="filter-modal-body">
              {filtersData.map((filter, index) => {
                const shouldRender = conditionalFields && conditionalFields[filter.name]
                  ? conditionalFields[filter.name](filter.value, watch)
                  : true;

                if (!shouldRender) return null;
                return renderFilter(filter, register, index)
              })}
            </Box>
            <Box className="pt-3 d-flex justify-content-end">
              <BaseButton buttonText={"Apply"} type="submit" />
            </Box>
          </form>
        </Box>
      </BaseCard>
    </BaseDrawer>
  );
}

export default DynamicFilter;
